import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { withTranslation } from 'language/i18n';

const PasswordReset = ({ t }) => (
  <div className="row justify-content-center">
    <div className="col-15 col-sm-8">
      <div className="row mb-5">
        <div className="col text-center">
          <div className="sign sign--success">
            <i className="fa-solid fa-check" />
          </div>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col text-center">
          <div className="fs-22 fw-700">{t('passwordChanged')}</div>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col text-center">
          <p>
            Hesabınızın şifresi güncellendi. Bu işlem size ait değilse lütfen müşteri temsilcimizle iletişime geçiniz.
          </p>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col">
          <Link href="/">
            <a className="im-button im-button--primary im-button--fluid im-button--center">
              {t('homepage')}
            </a>
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Link href="/login">
            <a className="im-button im-button--transparent im-button--fluid im-button--center">
              {t('login')}
            </a>
          </Link>
        </div>
      </div>
    </div>
  </div>
);

PasswordReset.propTypes = {
  t: PropTypes.func,
};

export default withTranslation('common')(PasswordReset);
